import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=4b2f4e74&scoped=true"
import script from "./DialogBox.vue?vue&type=script&lang=ts"
export * from "./DialogBox.vue?vue&type=script&lang=ts"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=4b2f4e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f4e74",
  null
  
)

export default component.exports